import React from "react";
import {withRouter} from "react-router-dom";


class AliPayJump extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            htmlString: null,
        }
    }

    componentDidMount() {
        this.init();
    }

    init = () => {
        let rount = 1;
        let _that = this;
        let content = '';
        let myVal = setInterval(function () {
            content = sessionStorage.getItem('alipayJump')
            console.log(content)
            if (content != null) {
                clearInterval(myVal);
                //sessionStorage.removeItem('alipayJump')
                _that.setState({htmlString: content});
                _that.handleSubmit();
            }
            if (rount > 3) {
                clearInterval(myVal)
            }
            rount++;
        }, 200)
    }

    handleSubmit = () => {
        let round = 1;
        let myVal = setInterval(function () {
            //支付宝Md5加签下单返回方式
            if (document.getElementById('alipaysubmit') !== null ) {
                clearInterval(myVal);
                document.forms['alipaysubmit'].submit();
            }

            if (document.getElementById('form1') !== null ) {
                clearInterval(myVal);
                document.forms['form1'].submit();
            }
            //支付宝RSA2加签下单返回方式
            if (document.getElementsByName('punchout_form') !== null ) {
                clearInterval(myVal);
                document.forms['punchout_form'].submit();
            }

            if (round > 20) {
                clearInterval(myVal);
            }

            round++;

        }, 200)

    };


    render() {

        const {htmlString} = this.state;

        return (
            <div dangerouslySetInnerHTML={{__html: htmlString}}/>
        );
    }
};

export default withRouter(AliPayJump);
